import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_GET_CHT_BIND_STATUS}`;

export const getChtBindStatus = () => axios.get(API_PATH);
